export default __webpack_public_path__ + "static/media/3.af21302a.jpg";